export const Glass = ({ variant = "light", as: Tag = "div", className = "", children, ...rest }) => (
  <Tag className={`glass glass-${variant} ${className}`} {...rest}>
    {children}
  </Tag>
);
